<template>
  <div class="scan-update-items--searchInput">
    <PgInput
      ref="refInput"
      class="area-scaninput"
      v-model="data.value"
      :placeholder="placeholder"
      prefix-icon="ivu-icon-icon-pg-serach"
      clearable
      @enter="onSearch"
    />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { PgInput } from '../../input/index'

const emit = defineEmits(['change'])

const data = reactive({
  value: '',
})

defineProps({
  placeholder: { type: String, default: '请输入关键字' },
})

const refInput = ref(null)

const onSearch = (keyword) => {
  console.log('keyword: ', keyword)
  data.value = keyword
  emit('change', keyword)
}

// 外部可调用的方法
// defineExpose({})
defineExpose({
  onClear() {
    data.value = ''
  },
})
</script>

<style lang="scss">
@import '../style/components/input-search.scss';
</style>
